'use strict';

angular.module('AcaApp').directive('ngComboBox', [
  '$timeout',
  function($timeout){
    return {
      restrict: 'A',
      scope: true,
      link: function(scope, $element){
        $element.addClass('combo-box');
        var label = $element.find('label');
        var options = $element.find('option');
        var comboBox = $element.find('select');
        var cssComboBox = {
          'color': 'rgba(0,0,0,0.54)',
          'order': '1',
          'pointer-events': 'none',
          '-webkit-font-smoothing': 'antialiased',
          'z-index': '1',
          'transform': 'translate3d(0px, 6px, 0px) scale(0.75)',
          'transition': 'transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1)',
          'transform-origin': 'left top 0px'
        };
        //jscs:disable maximumLineLength
        if(label[0] !== undefined && label[0].childNodes[0] !== undefined){
          var getComboValue = label[0].childNodes[0].data;
          var isState = scope.participantForm !== undefined && scope.form.state !== undefined && getComboValue === 'State';
          var isCountry = scope.participantForm !== undefined && scope.form.rescountrycode !== undefined && getComboValue === 'Country';
          var isStateE = (scope.form1094C !== undefined || scope.employerForm !== undefined) && scope.form.pstate !== undefined && getComboValue === 'State';
          var isTinTypeE = (scope.form1094C !== undefined || scope.employerForm !== undefined) && scope.form.ptintype !== undefined && getComboValue === 'TIN Type';
          var isCountryE = (scope.form1094C !== undefined || scope.employerForm !== undefined) && scope.form.rescountrycode !== undefined && getComboValue === 'Country';
          var isSelectedE = (scope.form1094C !== undefined) && scope.form.ptin !== undefined && getComboValue === 'Select Employer';

          if(isState || isCountry || isStateE || isTinTypeE || isCountryE || isSelectedE){
            label.css(cssComboBox);
          }
        }

        angular.forEach(options, function(value, key){
          var option = options[key];
          if(option.attributes.selected){
            $timeout(function(){
              $element.find('select').val(option.value);
            }, 100);
          }
        });
        /* istanbul ignore next */
        /* This a specific issue on material/IE that is adding a undefined value by default */
        comboBox.bind('focus', function(){
          var cb = comboBox[0];
          var firstOptionValue = cb[0].value;
          var lastOptionValue = cb[cb.length - 1].value.trim();
          if(firstOptionValue.match(/undefined/) !== null){
            cb[0].remove();
          }
          if(lastOptionValue === ''){
            cb[cb.length - 1].remove();
          }
          comboBox.unbind('focus');
        });
        comboBox.bind('change', function(){
          if(this.value === ''){
            label.show();
            if(scope.participantForm !== undefined || scope.employerForm !== undefined){
              label.css(
                {
                  'color': 'rgba(0,0,0,0.26)',
                  'order': '1',
                  'pointer-events': 'none',
                  '-webkit-font-smoothing': 'antialiased',
                  'z-index': '1',
                  '-webkit-transform': 'translate3d(0,28px,0) scale(1)',
                  'transform': 'translate3d(0,28px,0) scale(1)',
                  'transition': 'transform cubic-bezier(.25,.8,.25,1) .25s',
                  '-webkit-transform-origin': 'left top',
                  'transform-origin': 'left top'
                }
              );
            }
          }
          else{
            if(scope.participantForm !== undefined || scope.employerForm !== undefined){
              label.css(
                {
                  'color': 'rgb(63,81,181)',
                  '-webkit-transform': 'translate3d(0, 6px, 0) scale(0.75)',
                  'transform': 'translate3d(0, 6px, 0) scale(0.75)',
                  'transition': 'transform cubic-bezier(0.25, 0.8, 0.25, 1) 0.5s'
                }
              );
            }
            else{
              label.hide();
            }
          }
        });
        comboBox.bind('blur', function(){
          label.css(
              {
                'color': 'rgba(0,0,0,0.26)'
              }
            );
        });
        comboBox.bind('blur change', function(){
          if(this.required && !comboBoxHasValue(this.value)){
            comboBox.addClass('combo-box-required-field');
          }
          else{
            comboBox.addClass('combo-box-valid');
          }
        });
        $timeout(function(){
          var comboBoxCurrentValue = comboBox.val().trim();
          if(!comboBoxHasValue(comboBoxCurrentValue)){
            label.show();
          }
        });
        var comboBoxHasValue = function(value){
          return !(value.match('undefined') !== null || value === '');
        };
      }
    };
  }
]);
